import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { GroupMember } from '@era/security-sdk';
import { MemberUserStoreActions, MemberUserStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ListUserItemsComponent } from './list-user-items.component';

@Component({
  selector: 'era-security-member-list-user-items',
  templateUrl: 'member-list-user-items.container.html',
  styleUrls: ['./member-list-user-items.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ListUserItemsComponent, AsyncPipe],
})
export class MemberListUserItemsContainerComponent {
  private readonly store = inject(Store);

  public readonly isEditing = input(false);

  public readonly memberUsers$: Observable<GroupMember[]> = this.store.select(
    MemberUserStoreSelectors.selectCurrentGroupUsers
  );

  delete(user: GroupMember): void {
    this.store.dispatch(MemberUserStoreActions.GroupApiActions.memberUsersGroupDeleted({ memberUser: user }));
  }
}
